import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// i18n must be initialised before the first render, otherwise the login
// screen paints raw translation keys for one frame.
import './shared/i18n';
import './styles/globals.css';

import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
